import { useMemo } from 'react';
import { formatSize, getSelectionStyle, getPositionStyle } from '../utils/styleUtils';

export const useInputStyles = (props, enabled, isSelected, isHovered) => {
  const {
    width, maxWidth, minWidth, flex, flexGrow, flexShrink, flexBasis,
    backgroundColor, borderRadius, padding, style,
    position, top, left, right, bottom, unit, lockedEdges
  } = props;

  const containerStyle = useMemo(() => ({
    transition: 'all 0.2s ease',
    width: formatSize(width),
    maxWidth: formatSize(maxWidth),
    minWidth: formatSize(minWidth),
    flex: flex,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexBasis: flexBasis,
    boxSizing: 'border-box',
    backgroundColor: backgroundColor,
    borderRadius: borderRadius ? `${borderRadius}px` : undefined,
    padding: padding ? `${padding}px` : undefined,
    ...getPositionStyle({ position, top, left, right, bottom, unit, lockedEdges }),
    ...style,
    ...getSelectionStyle(enabled, isSelected, isHovered)
  }), [
    width, maxWidth, minWidth, flex, flexGrow, flexShrink, flexBasis,
    backgroundColor, borderRadius, padding, style,
    position, top, left, right, bottom, unit, lockedEdges,
    enabled, isSelected, isHovered
  ]);

  const labelStyle = useMemo(() => ({
    display: 'block',
    fontSize: `${props.labelFontSize}px`,
    fontFamily: props.fontFamily,
    fontWeight: props.labelBold ? 'bold' : 'normal',
    fontStyle: props.labelItalic ? 'italic' : 'normal',
    marginBottom: '4px',
    color: '#333'
  }), [props.labelFontSize, props.fontFamily, props.labelBold, props.labelItalic]);

  const inputStyle = useMemo(() => ({
    fontFamily: props.fontFamily,
    width: "100%"
  }), [props.fontFamily]);

  return { containerStyle, labelStyle, inputStyle };
};